export const tiktokCampaignKeys = {
    tiktokCampaign: (subdomain) => ['tiktokCampaign', subdomain],
    isUserRegistered: (subdomain, tiktokCampaignId) => ['tiktokCampaign', subdomain, 'isUserRegistered', tiktokCampaignId],
    leaderboard: (subdomain, tiktokCampaignId, page, pageSize) => ['tiktokCampaign', subdomain, 'leaderboard', tiktokCampaignId, page, pageSize],
    userRank: (subdomain, tiktokCampaignId) => ['tiktokCampaign', subdomain, 'userRank', tiktokCampaignId],
};
